export type SortKey = "file_name" | "code" | "cohort" | "date_uploaded";
export type SortDirection = "asc" | "desc";
export type SortState = { key: SortKey; direction: SortDirection };

export const DEFAULT_SORT: SortState = { key: "date_uploaded", direction: "desc" };

export function nextSort(current: SortState, key: SortKey): SortState {
  if (current.key === key) {
    return { key, direction: current.direction === "asc" ? "desc" : "asc" };
  }
  return { key, direction: key === "date_uploaded" ? "desc" : "asc" };
}
